import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import CreateRecitalModal from './components/CreateRecitalModal';
function recitalTagSlug() {
  var recitalTagId = app.forum.attribute('recitalsRecitalTagId') || 20;
  var tags = app.store && app.store.all ? app.store.all('tags') : [];
  for (var i = 0; i < tags.length; i++) {
    if (tags[i] && String(tags[i].id()) === String(recitalTagId)) {
      return tags[i].slug();
    }
  }
  return 'recital-hall';
}
function isRecitalHallPage() {
  var slug = recitalTagSlug();
  var path = window.location.pathname.replace(/\/+$/, '');
  return path.endsWith('/t/' + slug) || path.indexOf('/t/' + slug + '/') !== -1;
}
export default function addCreateRecitalButton() {
  extend(IndexPage.prototype, 'actionItems', function (items) {
    if (!app.forum.attribute('canPublishRecital')) return;
    if (!isRecitalHallPage()) return;
    items.add('createRecital', Button.component({
      icon: 'fas fa-plus',
      className: 'Button Button--primary Button--recitalCreate',
      onclick: () => app.modal.show(CreateRecitalModal)
    }, app.translator.trans('pianotell-recitals.forum.create_recital_button')), 90);
  });
}